import { Button, Tooltip } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { chrome, useThemeMode } from '@viq-admin/theme';

/**
 * Shared light/dark toggle — identical across both admin SPA shells (ADR 016).
 * Icon-button + tooltip; white so it reads on the navy header chrome.
 */
export function ThemeToggle() {
  const { mode, toggle } = useThemeMode();
  return (
    <Tooltip title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
      <Button
        type="text"
        aria-label="Toggle color theme"
        icon={mode === 'dark' ? <SunOutlined /> : <MoonOutlined />}
        onClick={toggle}
        style={{ color: chrome.onNavy }}
      />
    </Tooltip>
  );
}
